export default "__VITE_PUBLIC_ASSET__0b7b5865__"